import { cn } from '@/lib/utils';
import { ChatMarkdownRenderer } from '@/components/chat/ChatMarkdownRenderer';
import { toReadableMarkdown } from '@/lib/readable-markdown';
import type { FlowComposerMessage } from '@shared/types/flow-composer';
import { CheckProofLines } from './CheckProofLines';

interface ComposerMessageProps {
  message: FlowComposerMessage;
}

// Messages are always shown in full, like a regular chat.
export const ComposerMessage = ({ message }: ComposerMessageProps) => {
  const isUser = message.role === 'user';

  return (
    <div className={cn('flex flex-col', isUser ? 'items-end' : 'items-start')}>
      <div
        className={cn(
          'max-w-[90%] text-sm leading-relaxed',
          isUser
            ? 'rounded-2xl bg-domino-aubergine px-4 py-3 text-white shadow-sm'
            : 'px-1 py-1 text-domino-ink'
        )}
      >
        {isUser ? (
          <p className="whitespace-pre-wrap">{message.content}</p>
        ) : (
          <>
            <ChatMarkdownRenderer content={toReadableMarkdown(message.content)} />
            {/* The questions of the turn, apart: what the user answers next. */}
            {message.questions && message.questions.length > 0 && (
              <div className="mt-3 space-y-1.5 border-l-2 border-domino-aubergine pl-3">
                {message.questions.map((question) => <p key={question} className="font-medium text-domino-ink">{question}</p>)}
              </div>
            )}
          </>
        )}
      </div>
      {!isUser && message.checks && <CheckProofLines checks={message.checks} />}
    </div>
  );
};
